import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from 'next/components/ui';
import { easing } from 'next/components/ui/lib';
import MagicIcon from './MagicIcon';

const Wrapper = styled(Button)`
  align-items: center;
  background: var(--nav-install-bg);
  color: var(--nav-install-color);
  display: flex;
  font-size: var(--regular);
  font-weight: var(--bold);
  justify-content: center;
  padding: 8px;

  ${MagicIcon} {
    color: var(--nav-install-icon-color);
    margin-right: 8px;
    transition: ${easing('color')};
  }

  :hover {
    background: var(--nav-install-hover);

    ${MagicIcon} {
      color: var(--nav-install-icon-hover);
    }
  }
`;

function InstallButton({ className }) {
  return (
    <Wrapper
      forwardedAs={Link}
      className={className}
      to="/settings/installation"
    >
      <MagicIcon />
      Install to publish
    </Wrapper>
  );
}

InstallButton.propTypes = {
  className: PropTypes.string,
};

export default styled(InstallButton)``;
